import React, { useEffect, useState, useMemo } from "react";
import DataGridTable from "../../table/DataGridTable";
import ReportServices from "../../../services/ReportServices";

const columnsData = [
  { column: "sales_person", name: "Sales Person" },
  { column: "category", name: "Category" },
  { column: "new", name: "New" },
  { column: "hot", name: "Hot" },
  { column: "cold", name: "Cold" },
  { column: "warm", name: "Warm" },
  { column: "delivery", name: "Delivered" },
  { column: "lost", name: "Lost" },
  { column: "invalid", name: "Invalid" },
];

const salesData = [
  {
    sales_person: "Alice Johnson",
    category: "Senior",
    new: 15,
    hot: 10,
    cold: 5,
    warm: 8,
    delivered: 20,
    lost: 3,
    invalid: 1,
  },
  {
    sales_person: "Bob Smith",
    category: "Junior",
    new: 20,
    hot: 5,
    cold: 10,
    warm: 12,
    delivered: 15,
    lost: 8,
    invalid: 2,
  },
  {
    sales_person: "Charlie Davis",
    category: "Mid-Level",
    new: 10,
    hot: 7,
    cold: 8,
    warm: 10,
    delivered: 18,
    lost: 4,
    invalid: 4,
  },
  {
    sales_person: "Denise Williams",
    category: "Senior",
    new: 25,
    hot: 12,
    cold: 6,
    warm: 14,
    delivered: 22,
    lost: 5,
    invalid: 0,
  },
  {
    sales_person: "Edward Brown",
    category: "Junior",
    new: 18,
    hot: 4,
    cold: 9,
    warm: 11,
    delivered: 19,
    lost: 6,
    invalid: 3,
  },
];

const generateColumns = (columnsData) => [
  { field: "indexID", headerName: "ID", width: 90 },
  ...columnsData.map((field) => ({
    field: field.column,
    headerName: field.name.toUpperCase(),
    minWidth: 200,
    flex: 1,
    headerAlign: "left",
    align: "left",
  })),
];

const SalesReport = () => {
  const ReportService = new ReportServices();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await ReportService.getSalesReport();

      if (response && response.success) {
        const rowsData = response.data.map((item, index) => ({
          ...item,
          indexID: index + 1,
        }));
        setData(rowsData);
      } else {
        console.log("Invalid response or no data found");
        return [];
      }
    } catch (error) {
      console.error("Error retrieving data:", error);
      return [];
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const columns = useMemo(() => generateColumns(columnsData), []);

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-900">
      <div className="w-4/5 bg-white p-6 rounded-lg shadow-lg">
        <h4 className="text-3xl font-bold text-gray-800 uppercase tracking-wide border-b-2 border-gray-300 pb-2">
          Sales Person Report
        </h4>
        <DataGridTable data={data} columns={columns} />
      </div>
    </div>
  );
};

export default SalesReport;
